module.exports = __webpack_public_path__ + "static/img/preview-not-available.c1ae5d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview-not-available.jpg
// module id = e/cR
// module chunks = 1